/* Copyright Verge Technologies 2018
 * @file descriptionPanel.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component for displaying the description
 * panel on a product
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import ImageGallery from 'react-image-gallery';
import "./imageGallery.css";

const DescriptionPanel = (props) => {
  const { images, description, activeToggle } = props;
  const imageCat = []
  images.forEach(image => {
    imageCat.push({
      original: image,
      thumbnail: image,
    })
  })

  return (
    <div
      className="panels-page panels-description"
      style={{ display: activeToggle === 'DESCRIPTION' ? 'flex' : 'none', flexWrap: 'wrap' }}
    >
      {images.length > 0 &&
        <div className="image-block">
          <ImageGallery thumbnailClass={"thumbnail"} showPlayButton={false} useBrowserFullscreen={false} items={imageCat} />
        </div>}
      <div className="content-block" style={images.length === 0 ? { marginLeft: '0px' } : {}}>
        <div className="content" dangerouslySetInnerHTML={{ __html: description }} />
        {!description.replace(' ', '').length && <div className="message">No description available</div>}
      </div>
    </div>
  );
};

DescriptionPanel.propTypes = {
  activeToggle: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  images: PropTypes.array.isRequired,
};

export default DescriptionPanel;



// WEBPACK FOOTER //
// ./src/components/DescriptionPanel/descriptionPanel.js